import angular from 'angular';
import moment from "moment";
import 'moment-timezone';
import template from './countdown.tpl.html';
import './countdown.scss';

class CountdownController {

  constructor($rootScope, $window, $interval) {
    this.$rootScope = $rootScope;
    this.date = moment().format('YYYY');
    this.page = $rootScope.page;
    this.window = $window;
    this.$interval = $interval;
    this.clock = {total: 0, days: "00", hours: "00", minutes: "00", seconds: "00"}
    this.datetimes = '';
    this.timeinterval = '';
  }

  $onInit() {
    if(this.page.options.webinar.datetime) {
      this.datetimes = this.page.options.webinar.datetime.split(',');
      this.startCountdown()
    } else if (this.datetime) {
      this.datetimes = this.datetime.split(',');
      this.startCountdown()
    }
  }

  startCountdown() {
    this.nextdate = this.getDateTime(this.datetimes);
    this.deadline = moment.tz(this.nextdate, this.page.options.webinar.live_tz || 'America/New_York').utc().valueOf();//new Date(Date.parse(new Date()) + 15 * 24 * 60 * 60 * 1000);
    this.now = moment.tz(moment(), this.page.options.webinar.live_tz || 'America/New_York').utc().valueOf()
    this.clock.total = this.deadline - this.now
    if(this.clock.total > 0) {
      this.getTimeRemaining();
      this.timeinterval = this.$interval(() => {
        if(this.clock.total > 1000) {
          this.getTimeRemaining();
        } else {
          this.clock = {total: 0, days: "00", hours: "00", minutes: "00", seconds: "00"}
          this.stopInterval();
          if(this.storage !== undefined) {
            // Refresh the page
            this.$rootScope.$emit('countdownEnd', true);
          }
          this.window.location.reload();
        }
      }, 1000);
    }
  }

  stopInterval() {
    if (this.timeinterval) {
      this.$interval.cancel(this.timeinterval);
    }
  }

  getTimeRemaining() {
    this.now = moment.tz(moment(), this.page.options.webinar.live_tz || 'America/New_York').utc().valueOf()
    const total = this.deadline - this.now;
    const duration = moment.duration(total/1000/60/60, 'hours');
    const day = moment.duration(total/1000/60/60/24, 'days').asDays();
    const days = ('0' + Math.floor(day)).slice(-2);
    const seconds = ('0' + Math.abs(duration.seconds())).slice(-2);
    const minutes = ('0' + Math.abs(duration.minutes())).slice(-2);
    const hours = ('0' + Math.abs(duration.hours())).slice(-2);
    this.clock = {
      total,
      days,
      hours,
      minutes,
      seconds
    };
  }

  getDateTime(datetimes) {
    if(datetimes.length == 1)
      return datetimes[0];

    var dateArray = [];
    datetimes.forEach(datetime => {
      this.now = moment.tz(moment(), this.page.options.webinar.live_tz || 'America/New_York').utc().valueOf();
      this.stopDate = moment.tz(datetime.trim(), this.page.options.webinar.live_tz || 'America/New_York').utc().valueOf();
      dateArray.push(this.stopDate > this.now ? datetime : false);
    });
    let ndate = dateArray.filter(Boolean);
    return ndate[0];
  }

}

CountdownController.$inject = ["$rootScope", "$window", "$interval"];

class CountdownComponent {
  constructor() {
    this.bindings = {
      datetime: '@?',
      storage: '@?',
      theme: '@?'
    };
    this.transclude = true,
    this.template = template;
    this.controller = CountdownController;
  }
}


export default angular
.module('countdown.component', [])
.component('countdown', new CountdownComponent())
.name;
